import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import { useStoreActions, useStoreState } from 'easy-peasy';
import _e from 'common/localeUtil';
import { MESSAGE_TYPES } from '../../constants';
import GenericDialog from './GenericDialog';

const ShowMessageDialog = ({ open, handleClose }) => {
	const hideMessage = useStoreActions(actions => actions.showMessage.hideMessage);
	const showMessageData = useStoreState(state => state.showMessage.showMessageData);

	const { text, type } = showMessageData;
	let dialogTitle = `${_e('successful')}!`;
	if (type === MESSAGE_TYPES.FAIL) {
		dialogTitle = 'Error!';
	}

	return (
		<GenericDialog
			maxWidth="xs"
			title={dialogTitle}
			open={open}
			handleClose={handleClose}
			confirmButtonVariant="contained"
			confirmAction={hideMessage}
			content={<Typography variant="body1">{text}</Typography>}
		/>
	);
};

ShowMessageDialog.propTypes = {
	open: PropTypes.bool,
	handleClose: PropTypes.func
};

export default ShowMessageDialog;
